import React from 'react';
import { Landmark, Wallet, Zap, MapPin, Check } from 'lucide-react';
import { PAYMENT_METHOD_META } from './bookingStatusMeta';

const FALLBACK_ICONS = { landmark: Landmark, wallet: Wallet, bolt: Zap, field: MapPin };

export function PaymentMethodMark({ meta, className = 'h-4 w-4' }) {
  if (meta.logo) return <img src={meta.logo} alt={meta.label} className={`${className} object-contain`} />;
  const Ic = FALLBACK_ICONS[meta.icon] || Wallet;
  return <Ic className={className} style={{ color: meta.color }} />;
}

// Compact inline badge for showing payment method on a booking row/status page
export function PaymentMethodBadge({ methodId, testId }) {
  const meta = PAYMENT_METHOD_META[methodId];
  if (!meta) return null;
  return (
    <span
      data-testid={testId}
      className="inline-flex items-center gap-1.5 rounded-full border px-2 py-0.5 text-xs font-semibold"
      style={{ borderColor: `${meta.color}55`, background: `${meta.color}12` }}
    >
      <span className="flex h-4 w-4 shrink-0 items-center justify-center rounded-full bg-white p-0.5 shadow-sm">
        <PaymentMethodMark meta={meta} className="h-3 w-3" />
      </span>
      {meta.label}
    </span>
  );
}

// Selectable card used in the public booking form
export function PaymentMethodOption({ methodId, selected, onClick, testId }) {
  const meta = PAYMENT_METHOD_META[methodId];
  if (!meta) return null;
  return (
    <button
      type="button" onClick={onClick} data-testid={testId}
      className="flex items-center gap-2 rounded-lg border-2 px-3 py-2.5 text-xs font-bold transition-all"
      style={selected
        ? { borderColor: meta.color, background: `${meta.color}1F`, boxShadow: `0 0 0 3px ${meta.color}33` }
        : { borderColor: 'rgba(255,255,255,0.1)' }}
    >
      <span className="flex h-6 w-6 shrink-0 items-center justify-center rounded-full bg-white p-1 shadow-sm">
        <PaymentMethodMark meta={meta} className="h-4 w-4" />
      </span>
      <span className="flex-1 text-right text-slate-100">{meta.label}</span>
      {selected && <Check className="h-3.5 w-3.5" style={{ color: meta.color }} />}
    </button>
  );
}

// Row header used in owner's payment settings panel (light background)
export function PaymentMethodTitle({ methodId }) {
  const meta = PAYMENT_METHOD_META[methodId];
  if (!meta) return null;
  return (
    <span className="flex items-center gap-2">
      <span className="flex h-6 w-6 shrink-0 items-center justify-center rounded-full border p-1" style={{ borderColor: `${meta.color}40` }}>
        <PaymentMethodMark meta={meta} className="h-4 w-4" />
      </span>
      <span className="text-sm font-bold text-slate-800">{meta.label}</span>
    </span>
  );
}
